export default "__VITE_ASSET__023b82ff__"